/**
 * O que o botão de nova cotação do modal de cotação expirada faz, conforme onde o comprador
 * está. Decidido por nome de rota (`$route.name`), não por `pipeline.actualStep`, que não é
 * fonte de verdade confiável.
 */
export const DccExpiredActions = {
    // Refaz a simulação nesta mesma tela.
    REQUOTE: 'REQUOTE',
    // Cartão aberto, tela à frente dos dados do cartão: volta para os dados do cartão.
    GO_TO_CARD_DATA: 'GO_TO_CARD_DATA',
    // Cartão fechado, tela além do Review: volta para o Review do DoF.
    GO_TO_DOF_REVIEW: 'GO_TO_DOF_REVIEW',
    // Aberto no meio da finalização do pagamento: recarrega a página.
    RELOAD: 'RELOAD',
};

export const CARD_DATA_ROUTE = 'CardDataCred';
export const DOF_REVIEW_ROUTE = 'DataOnFileReview';

// Telas em que a simulação pode ser refeita direto: os dados do cartão (aberto) e o Review do DoF.
const REQUOTE_ROUTES = [
    'CardDataCred',
    'CardDataDebit',
    'CardDataVoucher',
    'CardDataMultibenefits',
    DOF_REVIEW_ROUTE,
];

// Cartão aberto: etapas que vêm depois dos dados do cartão.
const AFTER_CARD_DATA_ROUTES = ['PersonalData', 'Review'];

// Cartão fechado: etapas alcançadas a partir do Review do DoF.
const AFTER_DOF_REVIEW_ROUTES = [
    'DataOnFileEditCustomer',
    'DataOnFileAddresses',
    'DataOnFileEditAddress',
    'DataOnFileEditCard',
];

/**
 * @param {Object} params
 * @param {Boolean} params.duringFinalization O aviso nasceu no meio da finalização (3DS/envio).
 * @param {String} params.routeName Nome da rota atual.
 */
export function resolveDccExpiredAction({ duringFinalization, routeName }) {
    if (duringFinalization) return DccExpiredActions.RELOAD;

    if (REQUOTE_ROUTES.includes(routeName)) return DccExpiredActions.REQUOTE;

    if (AFTER_CARD_DATA_ROUTES.includes(routeName)) return DccExpiredActions.GO_TO_CARD_DATA;

    if (AFTER_DOF_REVIEW_ROUTES.includes(routeName)) return DccExpiredActions.GO_TO_DOF_REVIEW;

    return DccExpiredActions.REQUOTE;
}

/**
 * Para onde o comprador volta ao só fechar o modal (sem pedir nova cotação). A volta para a
 * moeda do pedido restaura o parcelamento de antes da adesão, e o comprador pode nem ter
 * escolhido parcela antes de aderir — então ele precisa rever a tela onde isso se decide:
 * os dados do cartão (cartão aberto) ou o Review do DoF (cartão fechado). Devolve `null` quando
 * ele já está numa dessas telas, ou fora de qualquer fluxo de cartão.
 */
export function resolveDccCloseRoute(routeName) {
    if (AFTER_CARD_DATA_ROUTES.includes(routeName)) return CARD_DATA_ROUTE;

    if (AFTER_DOF_REVIEW_ROUTES.includes(routeName)) return DOF_REVIEW_ROUTE;

    return null;
}

export default { resolveDccExpiredAction, resolveDccCloseRoute, DccExpiredActions, CARD_DATA_ROUTE, DOF_REVIEW_ROUTE };
